import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string) {
    this.showMessage(message, "snackbar-success");
  }

  showError(message: string) {
    this.showMessage(message, "snackbar-danger");
  }

  private showMessage(message: string, colorName: string) {
    this.snackBar.open(message, "X", {
      duration: 3500,
      verticalPosition: "bottom",
      horizontalPosition: "right",
      panelClass: colorName,
    });
  }
}
